import {useFormRenderContext} from "v4/components/form/FormRender/context/FormRenderContext";
import {useMemo} from "react";
import {CHOICE_TYPE} from "v4/data/fieldTypes";
import {useTranslation} from "react-i18next";

export default function useImportRowsInfos(fullData, identifierFormMethods, form) {
    const {t} = useTranslation();
    const {formRenderMethods, fields} = useFormRenderContext();

    const fieldsToWatch = fields.map(field => !field.name.includes('_action') ? field.name : null).filter(Boolean);

    const selectIdentifierManager = useMemo(() => {
        const identifierChoices = fields[1].choices.filter(({label}) => label.toLowerCase().endsWith('_identifier'));

        if (identifierChoices.length > 0) {
            const values = formRenderMethods.watch(fieldsToWatch);

            // Same choices than the first field of the form without the choices that are not already mapped to a column
            const choices = fields[0].choices.filter(({value}) => value !== '' && Object.values(values).includes(value));

            const form = {
                metadata: {},
                results: identifierChoices.reduce((acc, {label, value}) => {
                    const name = `select_identifier_${value}`;

                    acc[name] = {
                        attr: {
                            'unique-options-with': identifierChoices.map(({value: v}) => `select_identifier_${v}`).join('|'),
                        },
                        choices,
                        label: t(label),
                        multiple: true,
                        name,
                        required: true,
                        type: CHOICE_TYPE,
                        value: null,
                        onFieldChange(selectedFieldValues) {
                            const formValuesEntries = Object.entries(formRenderMethods.getValues())

                            const selectedColumns = formValuesEntries
                                .filter(([, fieldValue]) => selectedFieldValues.includes(fieldValue))
                                .map(([fieldName]) => fieldName);

                            const identifierFields = formValuesEntries
                                .filter(([, fieldValue]) => fieldValue === value);

                            // Remove value from all identifier fields that are not in the selected values
                            identifierFields.forEach(([fieldName, fieldValue]) => {
                                if (selectedColumns.includes(fieldValue)) return;

                                formRenderMethods.setValue(fieldName, 'update');
                            });

                            // Set value to all selected fields
                            selectedColumns.forEach((fieldName) => {
                                formRenderMethods.setValue(`${fieldName}_action`, value);
                            });
                        },
                    }

                    return acc;
                }, {}),
            };

            return {
                form,
                methods: identifierFormMethods,
            }
        }

        return null;
    }, [fields, fieldsToWatch, formRenderMethods, identifierFormMethods, t]);

    const values = formRenderMethods.watch(fieldsToWatch).map((value, index) => {
        if (value === undefined) {
            return form.results[fieldsToWatch[index]]?.value ?? null;
        }

        return value;
    });

    return {
        unmappedColumns: values.filter(value => !value).length,
        totalColumns: values.length,
        selectIdentifierManager,
    }
}
